import { Action } from '@ngrx/store';

export const SET_COUNTERS_NUMBERS = '[Header] set counters numbers';
export const SET_COUNTERS_NOTIFICATIONS = '[Header] set counters of notifications';
export const SET_COUNTERS_CART_INCREMENT = '[Header] increment counters of cart';
export const SET_COUNTERS_CART_DECREMENT = '[Header] decrement counters of cart';
export const SET_COUNTERS_WISHLIST_INCREMENT = '[Header] increment counters of wishlist';
export const SET_COUNTERS_WISHLIST_DECREMENT = '[Header] decrement counters of wishlit';
export const RESET_COUNTERS = '[Header] reset counters';
export const SET_PAGE_PARAMS = '[Navigation] set page parameters';
export const CLICK_ON_HEADER_BUTTON = '[Header] click on header button';
export const CLICK_ON_ACCESSIBILITY_TOP_LINK = '[Header] click on the accessibility link on the top';
export const SET_ME_BADGE = '[Header] set badge on icon me';

// COUNTERS HEADER BADGE

export class SetCountersnumbers implements Action {
  readonly type = SET_COUNTERS_NUMBERS;
  constructor(public payload: any) {}
}

export class SetCountersNotifications implements Action {
  readonly type = SET_COUNTERS_NOTIFICATIONS;
  constructor(public payload: number) {}
}

export class IncrementCountersCart implements Action {
  readonly type = SET_COUNTERS_CART_INCREMENT;
}

export class DecrementCountersCart implements Action {
  readonly type = SET_COUNTERS_CART_DECREMENT;
}

export class IncrementCountersWishList implements Action {
  readonly type = SET_COUNTERS_WISHLIST_INCREMENT;
}

export class DecrementCountersWishList implements Action {
  readonly type = SET_COUNTERS_WISHLIST_DECREMENT;
}

export class ResetCounters implements Action {
  readonly type = RESET_COUNTERS;
}

export class SetPageParams implements Action {
  readonly type = SET_PAGE_PARAMS;
  constructor(public payload: { [name: string]: string }) {}
}

export class ClickOnHeaderButton implements Action {
  readonly type = CLICK_ON_HEADER_BUTTON;
  constructor(public payload: { button_name: string }) {}
}

export class ClickOnAccessibilityTopLink implements Action {
  readonly type = CLICK_ON_ACCESSIBILITY_TOP_LINK;
  constructor(public payload: { event_name: string }) {}
}

export class SetBadgeMe implements Action {
  readonly type = SET_ME_BADGE;
  constructor(public payload: boolean) {}
}

export type HeaderActions =
  | SetCountersnumbers
  | SetCountersNotifications
  | IncrementCountersCart
  | DecrementCountersCart
  | IncrementCountersWishList
  | DecrementCountersWishList
  | ResetCounters
  | SetPageParams
  | ClickOnHeaderButton
  | ClickOnAccessibilityTopLink
  | SetBadgeMe;
